import { useTranslation } from 'react-i18next'
import React from 'react'
import Paper from '@material-ui/core/Paper'
import { isWidthUp } from '@material-ui/core/withWidth'
import { Tooltip, withStyles } from '@material-ui/core'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'

const useStyles = makeStyles((theme) =>
  createStyles({
    deforestationlegend: {
      position: 'fixed',
      left: (props) =>
        isWidthUp('sm', props.width)
          ? props.openDrawer
            ? props.drawerWidth +
            10 +
            (props.isDemLegendVisible ? 290 : 0)
            : props.isDemLegendVisible
              ? 300
              : 10
          : 10,
      zIndex: 400,
      bottom: (props) => (isWidthUp('sm', props.width) ? 16 : 60),
      display: 'flex',
      borderRadius: '20px',
      overflow: 'hidden',
      boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.3)',
      border: '3px solid white',
      width: 'auto',
      minWidth: 450,
      backgroundColor: 'white',
    },
    legendItem: {
      height: 34,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      fontSize: 13,
      color: '#FFFFFF',
      textShadow: '0px 0px 2px rgba(0, 0, 0, 0.5)',
      letterSpacing: 0.5,
      padding: '0 12px',
      position: 'relative',
      whiteSpace: 'nowrap',
    },
    helpIcon: {
      fontSize: 18,
      marginLeft: 6,
      color: 'white',
      cursor: 'help',
      opacity: 0.9,
      '&:hover': {
        opacity: 1,
      },
    },
    labelContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }
  })
)

// Deforestation risk classes. The legacy DEFORESTED / NOT DEFORESTED legend was
// removed: deforestation is only rendered from risk audits now.
const RISK_LEGEND = [
  { color: '#0066FF', label: 'LOW RISK' },
  { color: '#1EBBFF', label: 'MORE INFO NEEDED' },
  { color: '#FF0000', label: 'HIGH RISK' },
]

const DeforestationLayerLegend = ({
  openDrawer,
  drawerWidth,
  isDemLegendVisible,
  width,
}) => {
  const classes = useStyles({
    isDemLegendVisible,
    openDrawer,
    drawerWidth,
    width,
  })

  const { t } = useTranslation();
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(14),
      border: '1px solid #dadde9',
    },
  }))(Tooltip);

  return (
    <Paper className={classes.deforestationlegend} elevation={0}>
      {RISK_LEGEND?.map((l, index) => (
        <div 
          key={index} 
          className={classes.legendItem}
          style={{ 
            backgroundColor: l.color, 
            width: `${100 / RISK_LEGEND.length}%`,
            borderRadius: index === 0 ? '16px 0 0 16px' : index === RISK_LEGEND.length - 1 ? '0 16px 16px 0' : '0',
            minWidth: l.label === "MORE INFO NEEDED" ? '180px' : '120px'
          }}
        >
          <div className={classes.labelContainer}>
            {l.label}
            <HtmlTooltip
              title={<>{t(l.label)}</>}
              placement="top"
            >
              <HelpOutlineIcon className={classes.helpIcon} />
            </HtmlTooltip>
          </div>
        </div>
      ))}
    </Paper>
  )
}

export default DeforestationLayerLegend
